import { render, staticRenderFns } from "./ResourcesHome.vue?vue&type=template&id=0be1a1cc&"
import script from "./ResourcesHome.vue?vue&type=script&lang=js&"
export * from "./ResourcesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports